// import { BitfStrapiFormItemConfig } from '@common/libs/bitforce/core/models';
import * as Models from '@models';
import { PublicBundle, Garage } from '@models';

export const modelsMap = new Map<string, any>([
  ['users', Models.User],
  ['public-bundles', PublicBundle],
  ['garages', Garage],
  // ['form-items-config', BitfStrapiFormItemConfig],
]);
